import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Header from '../header';
import Footer from '../footer';
import { ThemeProvider } from '@mui/material/styles';
import {
  createTheme, styled
} from '@mui/material/styles';


const PREFIX = 'MaterialLayout';

const fontSize = 14; // px
const htmlFontSize = 16;
const coef = fontSize / 14;

export const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#ce0d28'
    },
    secondary: {
      main: '#8aaf45',
      contrastText: '#fff',
    },
    error: { main: '#f44336' }
  },
  typography: {
    fontFamily: "Rockwell-MT",
    pxToRem: size => `${(size / htmlFontSize) * coef}rem`,
  },
  shape: {
    borderRadius: 1
  },
  spacing: [0, 4, 8, 16, 32, 64],
});

const BoxSx = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  display: 'block',
  //width: '90%',
  //padding:theme.spacing(4),
  boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)'
}));


export default function MaterialLayout(props) {
  const { children } = props;
  return (
    <ThemeProvider theme={theme}>
      <Container fixed>
        <BoxSx>
          <Header {...props} />
          {children}
        </BoxSx>
        <br />
        <Footer />
      </Container>
    </ThemeProvider>
  );
}
